import React, { useState, useRef, useEffect, memo } from "react";
import { styled } from "@mui/material/styles";
import { Container } from "@mui/material/";
import Typography from "../../components/Typography";
import { useTranslation } from "react-i18next";
import {
  getUmbrellaMessage
} from "../../assets/hooks/functions";



const Icon = styled("img")(({ theme }) => ({
  width: "50px",
  bottom: 0,
  position: "relative",
  animation: "bounce 2s infinite",
  "@keyframes bounce": {
    "0%, 20%, 50%, 80%, 100%": {
      transform: "translateY(0)",
    },
    "40%": {
      transform: "translateY(-8px)",
    },
    "60%": {
      transform: "translateY(-5px)", // Bounce down
    },
  },
}));

const HeroInfo = memo(function HeroInfo({ zonti }) {
  const { t } = useTranslation();
  return (
    <Container
      sx={{
        display: "flex",
        minWidth: "100%",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      <Typography
        align="center"
        color="primary.red"
        sx={{ marginTop: "0.5rem", fontSize: "1.3rem", fontWeight: 900 }}
      >
        {t("header.table")} {getUmbrellaMessage(zonti)}
      </Typography>
      <Typography
        color="text.dark"
        align="center"
        sx={{ fontSize: "1.5rem", lineHeight: "1.6rem" }}
      >
        {t("header.call")}
      </Typography>
      <Icon src="/down1.png" alt="Argo_hand1" />
    </Container>
  );
} )
export default HeroInfo;
